import React from "react";
import pictureOne from "./assets/picOne.png";
import { Link } from "react-router-dom";

const StandardsServices = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">
            Overview Standards Development
          </h1>
          <p className="subtitle">
            Promoting standardization and quality assurance in Malawi.
          </p>
        </div>
      </section>

      {/* === Standards Development Section (Replaced Section) === */}
      <section className="what-section">
        {/* <h2 className="section-title">Standards Development</h2> */}
        <p>
          The MBS formulates national standards (Malawi Standards) in all fields
          of interest. The standards act as a base or guideline for measuring
          the quality, performance or fitness for intended use of a product or
          service.
          <br />
          <br />
          The formulation of standards is done through{" "}
          <Link
            to="/technicalCommittees"
            style={{ color: "red", textDecoration: "none" }}
          >
            Technical Committees (TCs)
          </Link>{" "}
          which are made up of representatives from the industry, government
          ministries and departments, professional organizations and bodies,
          among others.
          <br />
          <br />
          The Standards Development Department provides the secretariat for
          these committees. These TCs are grouped under three Divisions as
          follows:
        </p>

        <div className="standards-grid">
          <div className="standards-card">
            <h3>Chemicals and Textiles Division</h3>
            <p>
              TCs under this Division are responsible for the development of
              standards covering soaps, detergents, paints, pesticides,
              fertilizers, stationery and all products based on chemical
              formulations.
            </p>
          </div>
          <div className="standards-card">
            <h3>Engineering and Materials Division</h3>
            <p>
              TCs under this Division develop standards covering civil,
              electrical and mechanical engineering, information technology,
              renewable energy, building materials, etc.
            </p>
          </div>
          <div className="standards-card">
            <h3>Food and Agriculture Division</h3>
            <p>
              TCs under this Division are responsible for the development of
              standards covering food technologies, food safety, agricultural
              produce, livestock and livestock products, poultry and poultry
              products, etc.
            </p>
          </div>
        </div>
      </section>

      {/* === Background Section Still Kept === */}
      <section className="background-section">
        <div className="text-content">
          <h2 className="section-title">Our Commitment</h2>
          <p>
            The Malawi Bureau of Standards remains dedicated to supporting
            trade, industrial growth and consumer protection through the
            development, promotion and implementation of Malawi Standards.
          </p>
        </div>
        <div className="image-content">
          <img src={pictureOne} alt="Standards Services" />
        </div>
      </section>

      <br />
      <br />

      {/* === Inline CSS === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }

        .about-header {
          background-image: url(${pictureOne});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }

       .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          box-sizing: border-box;
          border-radius: 8px;
        }

        .page-title { font-size: 2.5rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .section-title {
          font-size: 1.8rem;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
        }

        .what-section { padding: 50px 80px; }
        .standards-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 25px;
          margin-top: 25px;
        }

        .standards-card {
          background: #ff6600;
          color: white;
          border-radius: 8px;
          padding: 22px;
          font-size: 1rem;
          line-height: 1.6;
        }

        .standards-card h3 {
          margin-bottom: 10px;
          font-size: 1.2rem;
          font-weight: bold;
        }

        .background-section {
          display: flex;
          align-items: center;
          gap: 40px;
          padding: 50px 80px;
        }

        .background-section img {
          width: 100%;
          max-width: 450px;
          border-radius: 8px;
        }

      `}</style>
    </div>
  );
};

export default StandardsServices;
